import {
  FormDataPost,
  Get,
  getAPIUrl,
  Post,
} from "../../ApiServices/apiMethod";

export const MatchEndpoint = {
  getBetList: "/user/all-game-bet-history?",
};

export const getBetList = (param = "") => {
  const url = getAPIUrl(MatchEndpoint.getBetList, param);
  return Get(url);
};
